var _title, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 23,
    style: {},
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glyphicons",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-flag",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.496989556755373,17.596044078950055 c0,0.2865433696059723 0,1.5673255937517359 0,1.5673255937517359 c0,0.1832544805619591 -0.14993548409614837,0.33318996465810735 -0.33318996465810735,0.33318996465810735 h-14.660358444956714 c-0.1832544805619591,0 -0.33318996465810735,-0.14993548409614837 -0.33318996465810735,-0.33318996465810735 c0,0 0,-1.2807822241457638 0,-1.5673255937517359 c0,-0.701698065569974 0.1326096059339267,-0.9895741950345791 0.6663799293162149,-1.2927770628734558 c0.4291486744796426,-0.24389505412973478 3.3105754888429524,-1.8998491784805278 4.6646595052135,-2.4815988567735823 v-2.510253193734179 c-0.4158210758933182,-0.3025364879095618 -0.6663799293162149,-0.7716679581481762 -0.6663799293162149,-1.4880263821631075 c0,-1.665949823290536 0,-1.988477709079584 0,-1.988477709079584 c0,-1.6492903250576303 0.9995698939743214,-2.9987096819229633 2.9987096819229633,-2.9987096819229633 s2.9987096819229633,1.3494193568653339 2.9987096819229633,2.9987096819229633 v1.988477709079584 c0,0.7090282447924523 -0.2505588534228968,1.1774933351017511 -0.6663799293162149,1.4813625828699448 v2.5169169930273414 c1.4373815075350744,0.5817496782930558 4.235510830733857,2.2370374227145313 4.6646595052135,2.4815988567735823 C24.364379950821448,16.606469883915473 24.496989556755373,16.895012393309393 24.496989556755373,17.596044078950055 zM25.49722583065901,3.503441333770752 H21.831469839490516 v5.6648957791171375 C21.831469839490516,9.350925213520533 21.988735502809142,9.50086069761668 22.16532618407794,9.50086069761668 C22.341916865346736,9.50086069761668 22.49784976880673,9.350925213520533 22.49784976880673,9.168337112887892 V7.5017209096680375 l3.023365739307664,-1.2094795717089288 C25.69114239009003,6.224270585168853 25.829749415387802,6.019025566939461 25.829749415387802,5.836437466306818 v-2.000472547807275 C25.829749415387802,3.6533768178669 25.67981393129165,3.503441333770752 25.49722583065901,3.503441333770752 z",
    id: "svg_1",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserKey);
export default __webpack_public_path__ + "static/media/user_key.5596e811bcdd13b24ba09eb0176c0bfd.svg";
export { ForwardRef as ReactComponent };